import React from 'react'
import { useDispatch } from 'react-redux'

import { openEditor } from '../../actioncreators/actioncreators'

const CreateExampleMap = () => {
  const dispatch = useDispatch()
  
  const openDialog = () => {
    window.amplitude.getInstance().logEvent('em_open_editor')
    dispatch(openEditor())
  }

  return (
    <div>
      <button onClick={openDialog} className='btn btn-primary'>Create Example Map</button>
    </div>
  )
}

export default CreateExampleMap
